import * as Yup from "yup";

export const dataModel = {
  itemCode: "",
  date: "",
  dateProd: "",
  dateExp: "",
  weight: "",
  copies: 1,
  harvestYear: 0,
};

export const validationDataModel = () => {
  return Yup.object().shape({
    itemCode: Yup.string().notRequired(""),
    date: Yup.date().notRequired(""),
    dateProd: Yup.date().notRequired(""),
    dateExp: Yup.date().notRequired(""),
    weight: Yup.number().notRequired(""),
    copies: Yup.number().notRequired(""),
    harvestYear: Yup.number().notRequired(""),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
